<template>
  <div class="module-box" :class="[noneStyle ? 'none-style' : '', customClass]">
    <div class="show-id" v-if="$route && $route.query && $route.query.showId == 1">{{ moduleId }}</div>
    <slot></slot>
    <div class="draggable-handle" v-if="mode === 'edit'">
      <svg t="1699607112779" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M966.057143 505.485714L820.228571 390.4a8.262857 8.262857 0 0 0-13.371428 6.514286V470.857143H553.142857V217.142857h74.057143c6.857143 0 10.742857-8 6.514286-13.371428L518.514286 57.942857a8.16 8.16 0 0 0-12.914286 0L390.4 203.771429a8.262857 8.262857 0 0 0 6.514286 13.371428H470.857143v253.714286H217.142857v-74.057143c0-6.857143-8-10.742857-13.371428-6.514286L57.942857 505.485714a8.16 8.16 0 0 0 0 12.914286l145.714286 115.2c5.371429 4.228571 13.371429 0.457143 13.371428-6.514286V553.142857h253.714286v253.714286h-74.057143c-6.857143 0-10.742857 8-6.514285 13.371428l115.2 145.714286c3.314286 4.228571 9.714286 4.228571 12.914285 0l115.2-145.714286c4.228571-5.371429 0.457143-13.371429-6.514285-13.371428H553.142857V553.142857h253.714286v74.057143c0 6.857143 8 10.742857 13.371428 6.514286l145.714286-115.2a8.342857 8.342857 0 0 0 0.114286-13.028572z"
        ></path>
      </svg>
    </div>
    <div class="mudule-edit-btns" v-if="mode === 'edit'">
      <edit-btns
        :edit-btns="eidtBtns"
        :more-btns="['copy', 'copyToClipboard']"
        :direction="'row'"
        @onAdd="handleAdd"
        @onSetup="handleSetup"
        @onDelete="handleDelete"
        @onMore="handleMore"
      ></edit-btns>
    </div>
  </div>
</template>

<script>
import EditBtns from "./EditBtns";
import Clipboard from "clipboard";

export default {
  name: "ModuleBox",
  components: { EditBtns },
  props: {
    mode: String,
    type: String,
    noneStyle: Boolean,
    showSetup: Boolean,
    customClass: String,
    moduleData: Object
  },
  data() {
    return {
      clipboard: null,
      moduleId: ""
    };
  },
  computed: {
    eidtBtns() {
      const btns = ["add", "delete"];
      if (this.showSetup) {
        btns.push("setup");
      }
      return btns;
    }
  },
  mounted() {
    this.moduleId = this.$el.getAttribute("id");
  },
  beforeDestroy() {
    // 销毁
    if (this.clipboard) this.clipboard.destroy();
  },
  methods: {
    handleAdd() {
      this.$emit("onAdd");
    },
    handleSetup() {
      this.$emit("onSetup");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    handleMore(command, data) {
      // 复制看模块内容到剪贴板
      if (command == "copyToClipboard") {
        if (this.moduleData) {
          const copyBtn = document.createElement("button");
          copyBtn.id = "copy-to-clipboard";
          copyBtn.setAttribute(
            "data-clipboard-text",
            "__illustrated_book_module_data__:" + JSON.stringify({ type: this.type, data: this.moduleData })
          );

          copyBtn.style.display = "none";
          document.body.appendChild(copyBtn);
          this.clipboard = new Clipboard(copyBtn);
          this.clipboard.on("success", e => {
            document.body.removeChild(copyBtn);
            this.$message({ message: "复制成功", type: "success" });
            e.clearSelection();
          });

          this.clipboard.on("error", e => {
            console.log(e);
            document.body.removeChild(copyBtn);
            this.$message({ message: "复制到剪贴板错误", type: "error" });
          });
          copyBtn.click();
        }
        return;
      }
      this.$emit("onMore", command, data);
    }
  }
};
</script>

<style lang="less" scoped>
.module-box {
  position: relative;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  &:last-child {
    margin-bottom: 0;
  }
  &.none-style {
    margin-bottom: 12px;
    padding: 0;
    background: transparent;
    border-radius: 8px;
    border: none;
  }
  .draggable-handle {
    position: absolute;
    top: 0;
    left: -30px;
    z-index: 10;
    width: 30px;
    height: 40px;
    background-color: transparent;
    cursor: move;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 2px 5px 2px rgba(64, 60, 67, 0.16);
    svg {
      width: 20px;
      height: 30px;
    }
  }
  .mudule-edit-btns {
    display: inline-flex;
    position: absolute;
    top: -20px;
    right: 0;
    padding-bottom: 3px;
  }
  .show-id {
    width: 100%;
    position: absolute;
    top: -20px;
  }
}
</style>
